import { useSyncExternalStore } from 'react';

/** Dos marcos (componentes.md, movil-e-ios.md): móvil < 1024 px y ordenador ≥ 1024 px. No hay marco de tablet. */
export const CORTE_ORDENADOR = 1024;

function consulta(texto: string) {
    return {
        suscribir: (aviso: () => void) => {
            if (typeof window === 'undefined') {
                return () => undefined;
            }
            const mq = window.matchMedia(texto);
            mq.addEventListener('change', aviso);
            return () => {
                mq.removeEventListener('change', aviso);
            };
        },
        leer: () => typeof window !== 'undefined' && window.matchMedia(texto).matches,
    };
}

const ordenador = consulta(`(min-width: ${String(CORTE_ORDENADOR)}px)`);
const fino = consulta('(hover: hover) and (pointer: fine)');

/** ¿Marco de móvil? Al girar el dispositivo cambia el marco sin perder lo abierto (el estado vive arriba). */
export function useEsMovil(servidor = false): boolean {
    return !useSyncExternalStore(ordenador.suscribir, ordenador.leer, () => !servidor);
}

/** ¿Ratón o trackpad? Con él, las filas del menú se reparten el alto (0.1, §1g); en táctil, 44. */
export function usePunteroFino(): boolean {
    return useSyncExternalStore(fino.suscribir, fino.leer, () => true);
}

export function useAnchoVentana(): number {
    return useSyncExternalStore(
        (aviso) => {
            window.addEventListener('resize', aviso);
            return () => {
                window.removeEventListener('resize', aviso);
            };
        },
        () => window.innerWidth,
        () => 1440,
    );
}
